import { useState, useEffect, useCallback } from 'react';
import API from './api';

const DEFAULT = {
  usage:        { stories: 0, narrations: 0, cloneNarrations: 0, regens: 0, photoIllustrations: 0 },
  limits:       { stories: 5, narrations: 0, cloneNarrations: 0, regens: 0, photoIllustrations: 0 },
  topUpCredits: { stories: 0, narrations: 0, cloneNarrations: 0, regens: 0, photoIllustrations: 0 },
};

const useLimits = () => {
  const [data, setData]     = useState(DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    API.get('/subscriptions')
      .then(res => {
        const { usage, limits, topUpCredits } = res.data;
        if (usage && limits) setData({ usage, limits, topUpCredits: topUpCredits || DEFAULT.topUpCredits });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Effective remaining = (plan limit - used) + topup credits
  const remaining = {
    stories:             Math.max(0, data.limits.stories - data.usage.stories) + (data.topUpCredits.stories || 0),
    narrations:          Math.max(0, data.limits.narrations - data.usage.narrations) + (data.topUpCredits.narrations || 0),
    cloneNarrations:     Math.max(0, data.limits.cloneNarrations - data.usage.cloneNarrations) + (data.topUpCredits.cloneNarrations || 0),
    regens:              Math.max(0, data.limits.regens - data.usage.regens) + (data.topUpCredits.regens || 0),
    photoIllustrations:  Math.max(0, data.limits.photoIllustrations - data.usage.photoIllustrations) + (data.topUpCredits.photoIllustrations || 0),
  };

  return { ...data, remaining, loading, refresh };
};

export default useLimits;
